import { format } from 'date-fns';

export const useSeo = () => {
  const { page } = usePage();
  const { lang } = useLanguage();
  const bookingData = useBooking();
  const { accommodationsData } = useSetup();
  const { checkout } = useCheckout();
  const { data: authData } = useAuth('aminess');

  const config = useRuntimeConfig();

  function setDefaultDataLayer(pageType) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.unshift({
        'event_data': {
          'environment': config?.public?.environment,
          'page_type': pageType || page?.value?.seo_page_type || 'other',
          'language': lang.value || ''
        },
          'user_data': {
          'login_method' : authData.value && Object.keys(authData.value).length ? 'email' : 'guest',
          'user_id': authData.value?.loyalty?.card_number || undefined,
        }
      });
    } catch(error) {}
  }

  function setCheckoutDataLayer(step, paymentType) {
    try {
      const stepsMapper = { 1: 'begin_checkout', 2: 'add_shipping_info', 3: 'add_payment_info' };
      let dataLayer = {
        'event': stepsMapper[step || 1],
        'ecommerce': {
          'value': parseFloat((checkout.value?.reservation?.price?.amount / 100 || 0).toFixed(2)),
          'currency': `${ checkout.value?.reservation?.price?.currency }` || 'EUR',
          'items': createDataLayerItems()
        }
      }

      if (step === 3) dataLayer.ecommerce.payment_type = paymentType === 'BANKTRANSFER' ? 'Bank transfer' : 'Credit card';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(dataLayer);
    } catch(error) {}
  }

  function setThankYouDataLayer(data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        'event': 'purchase',
        'ecommerce': {
          'transaction_id': data?.external_id || '',
          'affiliation': 'aminess.hr',
          'value': parseFloat((checkout.value?.reservation?.price?.amount / 100 || 0).toFixed(2)),
          'currency': `${ checkout.value?.reservation?.price?.currency }` || 'EUR',
          'payment_type': data?.payment_type === 'BANKTRANSFER' ? 'Bank transfer' : 'Credit card',
          'items': createDataLayerItems(),
        },
        'customer_data': {
          'first_name': data?.reservation_holder?.first_name || '',
          'last_name': data?.reservation_holder?.last_name || '',
          'address':  data?.reservation_holder?.address || '',
          'city': data?.reservation_holder?.city || '',
          'postcode': data?.reservation_holder?.zip_code || '',
          'country': data?.reservation_holder?.country_code || '',
          'email': data?.reservation_holder?.email || '',
          'phone': data?.reservation_holder?.phone_number || ''
        }
      });
    } catch(error) {}
  }

  function createDataLayerItems() {
    const items = [];
    const reservation = checkout.value?.reservation;
    const reservationResponseUnits = reservation?.units;
    const bookingUnits = bookingData.units.value;
    const selectedAccommodation = accommodationsData.value[bookingData.booking.value.accommodation.id];

    if (reservationResponseUnits?.length) {
      for (let unit in reservationResponseUnits) {
        const unitFromBookingUnits = bookingUnits.find(bookingUnit => bookingUnit.shape_id === `${ reservationResponseUnits[unit].details?.external_id }_${ unit }`);
        items.push({
          'item_id': `${ selectedAccommodation.id }`,
          'item_name': selectedAccommodation.name,
          'item_category': selectedAccommodation.kind === 'CAMP' ? 'Campsites' : 'Hotels and resorts',
          'item_category2': selectedAccommodation.place?.name,
          'item_brand': selectedAccommodation.brand?.name,
          'item_list_name': undefined,
          'item_list_id': undefined,
          'index': 1,
          'check_in_date': reservation.date_from ? format(reservation.date_from, 'dd-MM-yyyy') : '',
          'check_out_date': reservation.date_to ? format(reservation.date_to, 'dd-MM-yyyy') : '',
          'no_nights': parseInt(reservation.nights_count) || 0,
          'no_adults': unitFromBookingUnits?.adults_count || 0,
          'no_children': unitFromBookingUnits?.children_age?.length || 0,
          'coupon': bookingData.booking?.value?.promo_code || undefined,
          'item_variant': reservationResponseUnits[unit].details?.name || '',
          'item_offer': undefined,
          'item_options': reservationResponseUnits[unit].board,
          'currency': `${ reservationResponseUnits[unit].currency }` || 'EUR',
          'price': parseFloat((reservationResponseUnits[unit].amount / 100 || 0).toFixed(2)),
          'quantity': 1
        });
      }
    }

    return items;
  }

  return {
    setDefaultDataLayer,
    setCheckoutDataLayer,
    setThankYouDataLayer,
  }
}